import { ModalContent } from '@components/modal';
import AdditionalInfoRequest from './AdditionalInfoRequest';
import { useModal } from '@src/stores';
import { useQuery } from '@tanstack/react-query';
import ModalLoader from '@src/app-components/loader/ModalLoader';
import { ADDITIONAL_INFO_QUERY_KEYS, AdditionalInfoQueries } from '@src/api/services/additional-info';
import { UserPermissions } from '@src/utils/enums';
import './additionalInfoRequest.scss';
import RequestPermissionDisplay from '@src/app-components/permission-display/RequestPermissionDisplay';

const AdditionalInfoRequestModal = ({ ormAdditionalInfoActionID, requestID, version, canRespond = true }) => {
  const { closeModal } = useModal();

  const {
    data: additionalInfoFullData,
    isLoading: isLoadingAdditionalInfoFullData,
    isRefetching: isSaving,
  } = useQuery({
    queryKey: [ADDITIONAL_INFO_QUERY_KEYS.GET_ADDITIONAL_INFO_FULL, ormAdditionalInfoActionID, requestID, version],
    queryFn: () => AdditionalInfoQueries.getAdditionalInfoDetails(ormAdditionalInfoActionID, requestID, version),
  });

  const isReadOnly = !canRespond || additionalInfoFullData?.permission === UserPermissions.ReadOnly;
  if (isLoadingAdditionalInfoFullData) {
    return <ModalLoader title='Additional Information Request' />;
  }
  if (!additionalInfoFullData) {
    return <></>;
  }

  return (
    <ModalContent
      title={
        <div className='modal-title-with-permission'>
          Additional Information Request
          {additionalInfoFullData?.permission && (
            <RequestPermissionDisplay permission={additionalInfoFullData?.permission} />
          )}
        </div>
      }
    >
      <AdditionalInfoRequest
        data={additionalInfoFullData}
        onClose={closeModal}
        isReadOnly={isReadOnly}
        isSaving={isSaving}
      />
    </ModalContent>
  );
};

export default AdditionalInfoRequestModal;
